import React, { Fragment } from "react";


/**
 * props:
 * 		- txhash (if contains a prefix, will remove it)
 */
export function ShortTxHash(props) {

	const nb_keep = 3 // how many chars to keep on each side

	var txhash = props.txhash
	const prefix = txhash.split(':')[0] + ':'
	const short_txhash = shortTxHash(txhash, nb_keep)
	return (
		<Fragment>
			{short_txhash}
		</Fragment>
	)
}

// function version
export function shortTxHash(txhash, nb_keep = 3) {
	if (txhash.split(':').length >= 2) txhash = txhash.split(':')[1]
	if (!txhash || txhash.length < nb_keep * 2 + 1) return ""
	return " " + txhash.slice(0, nb_keep + 1) + "..." + txhash.slice(-nb_keep)
}
